import React, { useState, Dispatch, FunctionComponent, SetStateAction } from 'react';
import _ from 'lodash';
import { Modal as BootstrapModal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import {
  EDIT_BUTTON_TEXT,
  MARKET_DATA_QUESTIONNAIRE_HEADER,
  MarketDataQuestionnaireDescription,
  MarketDataQuestionnaireForm,
  Modal,
  SUBMIT_WARNING,
  TEMP_DELAYED_QUOTES_WARNING,
} from '@tradingblock/components';
import Config from '../../../config';
import { useApiToken, useStateSelector } from '../../../data/global/dataSelectors';
import { UIActions } from '../../../data/global/actions';

export const MarketDataQuestionnaire: FunctionComponent<{
  show: boolean;
  toggleModal: () => void;
  setShouldRefetchProfileData: Dispatch<SetStateAction<boolean>>;
  setShouldRefetchAccountManagementDetailsData: Dispatch<SetStateAction<boolean>>;
}> = ({ show, toggleModal, setShouldRefetchProfileData, setShouldRefetchAccountManagementDetailsData }) => {
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [submitBtnText, setSubmitBtnText] = useState<string>('');
  const [submitBtnRef, setSubmitBtnRef] = useState<HTMLButtonElement | null>(null);
  const [showTempDelayedQuotesWarning, setShowTempDelayedQuotesWarning] = useState<boolean>(false);

  const showPendingEntitlementModal = useStateSelector(s => s.ui.dashboard.entitlements.showPendingEntitlementModal);
  const isPendingMarketDataEntitlementPolicyUpdatePresent = useStateSelector(s =>
    s.account.profile.current &&
    s.account.profile.current.entitlement &&
    s.account.profile.current.entitlement.isPendingMarketDataEntitlementPolicyUpdatePresent);
  const defaultAccountId = useStateSelector(s => s.account.profile.current && s.account.profile.current.defaultAccountId);
  const selectedAccountId = useStateSelector(s => s.account.accountId);

  const accountIdOfAuthUserIsSameAsSelectedAccountId = defaultAccountId === selectedAccountId;

  const apiToken = useApiToken();

  const dispatch = useDispatch();

  return (
    <Modal show={show} setShow={() => toggleModal()} className="market-data-questionnaire-modal">
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>{MARKET_DATA_QUESTIONNAIRE_HEADER}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body className="txt-sm">
        <MarketDataQuestionnaireDescription />
        <MarketDataQuestionnaireForm
          apiToken={apiToken}
          rootRestHubUrl={Config.tradingApi}
          useCustomBtnPositioning
          useCustomErrorMsgPositioning
          onSubmissionSuccess={() => {
            toggleModal();

            if (isPendingMarketDataEntitlementPolicyUpdatePresent && !showPendingEntitlementModal) {
              dispatch(UIActions.setShowPendingEntitlementModal({ showPendingEntitlementModal: true }));
            }
          }}
          setSubmitBtnRef={setSubmitBtnRef}
          setSubmitBtnDisabled={setSubmitBtnDisabled}
          setErrorMsg={setErrorMsg}
          setSubmitBtnText={setSubmitBtnText}
          setShouldRefetchProfileData={setShouldRefetchProfileData}
          setShouldRefetchAccountManagementDetailsData={setShouldRefetchAccountManagementDetailsData}
          setShowTempDelayedQuotesWarningWithCustomPositioning={setShowTempDelayedQuotesWarning}
          accountId={defaultAccountId}
          accountIdOfAuthUserIsSameAsSelectedAccountId={accountIdOfAuthUserIsSameAsSelectedAccountId}
        />
      </BootstrapModal.Body>
      <BootstrapModal.Footer className="txt-sm">
        <div className="d-flex justify-content-center align-items-center flex-direction-col">
          <p className="fw-bold">{SUBMIT_WARNING}</p>
          {showTempDelayedQuotesWarning && <p className="fw-bold">{TEMP_DELAYED_QUOTES_WARNING}</p>}
          <div className="d-flex justify-content-flex-end w-100">
            <Button
              variant="secondary"
              onClick={() => toggleModal()}
              className="mr-1"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => submitBtnRef && submitBtnRef.click()}
              disabled={submitBtnDisabled}
              className="ml-1 submit-btn"
            >
              {submitBtnText || EDIT_BUTTON_TEXT}
            </Button>
          </div>
          <p className="mb-0 mt-3 error w-100 text-align-center">{errorMsg}</p>
        </div>
      </BootstrapModal.Footer>
    </Modal>
  );
};
